import { useState } from "react";

import {
  Tooltip,
  // Grid,
  // Stack,
  // Button,
  // TextField,
  // Typography,
  IconButton,
  // FormControl,
  // Select,
  // MenuItem,
  Box,
  // Dialog,
  // DialogTitle,
  // DialogContent,
} from "@mui/material";

// import { useMutation, useQuery } from "@apollo/client"
//icons
// import { CiCircleList } from "react-icons/ci";
// import { FaRegEye } from "react-icons/fa";
// import { BiMinusCircle } from "react-icons/bi";
import { RiFilePaper2Fill } from "react-icons/ri";
//src
import "../../../Style/actionstyle.scss";
import ViewAjdIn from "./ViewAjdIn";
import { TbEdit } from "react-icons/tb";
import UpdateAjustIn from "./UpdateAjustIn";

export default function ViewAdjInAction({ editData, setRefetch }) {
  // 
  const [openView, setOpenView] = useState(false);
  const handleOpenView = () => setOpenView(true);
  const handleCloseOpenView = () => setOpenView(false);

  // 
  const [openUpdate, setOpenUpdate] = useState(false);
  const handleOpenUpdate = () => setOpenUpdate(true);
  const handleCloseOpenUpdate = () => setOpenUpdate(false);

  // console.log("adjInData}++_+_}_", adjInData)

  return (
    <div>
      <Tooltip title="ពិនិត្យការផ្ទេរចូល" placement="top">
        <IconButton onClick={handleOpenView}>
          <Box className="view-container">
            <RiFilePaper2Fill className="view-icon" />
          </Box>
        </IconButton>
      </Tooltip>

      <Tooltip title="កែប្រែការផ្ទេរចូល" placement="top">
        <IconButton onClick={handleOpenUpdate}>
          <Box className="update-container">
            <TbEdit className="view-icon" />
          </Box>
        </IconButton>
      </Tooltip>

      {
        openView &&
        <ViewAjdIn
          open={openView}
          handleClose={handleCloseOpenView}
          editData={editData}
        />
      }

      {
        openUpdate &&
        <UpdateAjustIn
          open={openUpdate}
          handleClose={handleCloseOpenUpdate}
          editData={editData}
          setRefetch={setRefetch}
        />
      }
    </div>
  );
}
